// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const SvgIconCheckbox = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2zM6 3a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3H6z"
      fill="#8490A4"
    />
  );
export default SvgIconCheckbox;
